import { Box, Button, Flex, Table, TableContainer, Tbody, Td, Tr } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import TableActions from '../../common/TableActions/TableActions';
import TableHeader from '../../common/TableHeader/TableHeader';
import useItemLister from '../../core/hooks/useItemLister';
import { CommunityRole } from '../../core/models';

const FILTERS = ['name'];

const COLS: {
  label: string;
  sort?: string;
  isNumeric?: boolean;
}[] = [
  {
    label: 'Name',
    sort: 'name',
  },
  {
    label: 'Published',
    sort: 'published',
  },
  {
    label: 'Actions',
    isNumeric: true,
  },
];

function CommunityRoleLister() {
  const navigate = useNavigate();
  const { items, activeId, deleteItem, deleteLoading, Lister, sort, changeSort, setIsActive } =
    useItemLister({
      endpointSingle: 'community_role',
      endpointPlural: 'community_roles',
      filters: FILTERS,
    });

  useEffect(() => {
    setIsActive(true);

    return () => {
      setIsActive(false);
    };
  }, []);

  return (
    <>
      <Flex>
        <h1 className="h3">Community role</h1>
        <Button
          colorScheme="messenger"
          type="button"
          shadow="lg"
          ml="auto"
          onClick={() => navigate(`/community-role/new`)}
        >
          Create New
        </Button>
      </Flex>
      {Lister({
        children: (
          <Box my={5}>
            <TableContainer fontSize="1rem" boxShadow="xl">
              <Table variant="striped" colorScheme="facebook">
                <TableHeader cols={COLS} sort={sort} changeSort={changeSort} />
                <Tbody>
                  {items?.map((communityRole: CommunityRole) => (
                    <Tr key={communityRole._id}>
                      <Td p={2} verticalAlign="middle">
                        <button
                          style={{ padding: '6px' }}
                          type="button"
                          onClick={() => navigate(`/community-role/${communityRole._id}`)}
                        >
                          {communityRole.name}
                        </button>
                      </Td>
                      <Td
                        p={2}
                        verticalAlign="middle"
                        style={{ color: communityRole.published ? 'green' : '' }}
                      >
                        {communityRole.published ? 'Published' : 'Unpublished'}
                      </Td>
                      <Td p={2} verticalAlign="middle">
                        <TableActions
                          item={communityRole}
                          path="community-role"
                          activeId={activeId}
                          deleteItem={deleteItem}
                          deleteLoading={deleteLoading}
                        />
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        ),
      })}
    </>
  );
}

export default CommunityRoleLister;
